module.exports = __webpack_public_path__ + "static/media/stijn-bessem-logo-vodafone.97f292ad.svg";